import React from "react";
import LegalPage from "@/components/LegalPage";
import { PRIVACY_INTRO, PRIVACY_SECTIONS } from "@/content/legal";

export default function Privacy() {
  return <LegalPage title="Privacy Policy" intro={PRIVACY_INTRO} sections={PRIVACY_SECTIONS} />;
}
